<div class="route-component">
    <div class="form-component">

        <tab-control>
            <tab-page title="User Report" icon="fas fa-users">
                <h4>
                    No input required to run this report
                </h4>

                <!-- Action Bar -->
                <div class="action-bar">
                    <button class="button" (click)="onRunReport()">
                        <i class="fas fa-fire"></i>
                        Run Report
                    </button>
                </div>
            </tab-page>
        </tab-control>

    </div>
</div>